import { nonEmptyOrUndefined, parseIdList, splitList } from '~/utils/lists'
import {
  type TaskLinkedTo,
  type TaskListFilters,
  taskLinkedToLabels
} from '../types'
import type { UseTasksParams } from './tasks'

const isTaskLinkedTo = (value: string): value is TaskLinkedTo =>
  value in taskLinkedToLabels

export const buildTaskListParams = (
  filters: TaskListFilters,
  now = new Date()
): UseTasksParams => {
  const status = filters.status ?? 'todo'

  const scheduledDate: { after?: string; before?: string } = {}
  if (filters.dueAfter) {
    scheduledDate.after = filters.dueAfter
  }
  if (filters.dueBefore) {
    scheduledDate.before = filters.dueBefore
  }
  if (status === 'overdue') {
    const dueBefore = filters.dueBefore ? new Date(filters.dueBefore) : null
    scheduledDate.before =
      dueBefore && dueBefore < now ? filters.dueBefore : now.toISOString()
  }

  return {
    user: nonEmptyOrUndefined(parseIdList(filters.user)),
    agency: nonEmptyOrUndefined(parseIdList(filters.agency)),
    contacts: nonEmptyOrUndefined(parseIdList(filters.contacts)),
    applicants: nonEmptyOrUndefined(parseIdList(filters.applicants)),
    createdBy: nonEmptyOrUndefined(parseIdList(filters.createdBy)),
    completedBy: nonEmptyOrUndefined(parseIdList(filters.completedBy)),
    linkedTo: nonEmptyOrUndefined(
      splitList(filters.linkedTo).filter(isTaskLinkedTo)
    ),
    types: nonEmptyOrUndefined(splitList(filters.type)),
    isCompleted: false,
    treated: status === 'completed',
    scheduledDate:
      scheduledDate.after || scheduledDate.before ? scheduledDate : undefined,
    itemsPerPage: 30
  }
}
